// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"bb4c99f2","566":"d1608661"}[chunkId] + ".chunk.js";
};